import { AxiosInstance } from "axios";
import type {
  JiraIssueType,
  JiraProject,
  JiraResource,
  JiraStatus,
} from "./JiraSourceSettings.types";

export class JiraSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getResources(
    boardId: string,
    connectionId: string,
  ): Promise<JiraResource[]> {
    const response = await this.client.get<JiraResource[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/jira/resources`,
    );

    return response.data;
  }

  async getProjects(
    boardId: string,
    connectionId: string,
    resourceId: string,
  ): Promise<JiraProject[]> {
    const response = await this.client.get<JiraProject[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/jira/projects?resourceId=${encodeURIComponent(resourceId)}`,
    );

    return response.data;
  }

  async getIssueTypes(
    boardId: string,
    connectionId: string,
    resourceId: string,
  ): Promise<JiraIssueType[]> {
    const response = await this.client.get<JiraIssueType[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/jira/issueTypes?resourceId=${encodeURIComponent(resourceId)}`,
    );

    return response.data;
  }

  async getStatuses(
    boardId: string,
    connectionId: string,
    resourceId: string,
  ): Promise<JiraStatus[]> {
    const response = await this.client.get<JiraStatus[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/jira/status?resourceId=${encodeURIComponent(resourceId)}`,
    );

    return response.data;
  }
}
